import React from "react";
import { Clock } from "lucide-react";
import { Field, Input, Toggle, SectionTitle } from "../primitives";
import { WEEK_DAYS } from "../constants";

export default function Step7Schedule({ form, set }) {
  const setDay = (k, patch) =>
    set({ working_hours: { ...form.working_hours, [k]: { ...form.working_hours[k], ...patch } } });

  const disabled = form.is_24_7 || form.vacation_mode;

  return (
    <div className="space-y-6">
      <SectionTitle icon={Clock} title="Working hours"
        subtitle="Let clients know when you're typically available." />

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        <div className="px-3 py-3 rounded-lg bg-stone-900/50 border border-stone-800">
          <Toggle
            checked={form.available_now}
            onChange={(v) => set({ available_now: v })}
            label="Available right now"
            testid="schedule-available-now"
          />
        </div>
        <div className="px-3 py-3 rounded-lg bg-stone-900/50 border border-stone-800">
          <Toggle
            checked={form.is_24_7}
            onChange={(v) => set({ is_24_7: v })}
            label="Available 24 / 7"
            testid="schedule-24-7"
          />
        </div>
        <div className="px-3 py-3 rounded-lg bg-stone-900/50 border border-stone-800">
          <Toggle
            checked={form.vacation_mode}
            onChange={(v) => set({ vacation_mode: v })}
            label="Vacation mode"
            testid="schedule-vacation"
          />
        </div>
      </div>

      <Field label="Weekly schedule">
        <div className="rounded-xl border border-stone-800 bg-stone-950/40 divide-y divide-stone-800/80">
          {WEEK_DAYS.map((d) => {
            const cfg = form.working_hours[d.k] || { open: "10:00", close: "22:00", closed: false };
            return (
              <div key={d.k} className="p-3 grid grid-cols-[80px_1fr] sm:grid-cols-[120px_1fr_auto] items-center gap-2 sm:gap-3" data-testid={`schedule-day-${d.k}`}>
                <div className="text-sm text-stone-200">{d.label}</div>
                <div className="flex items-center gap-1.5">
                  <Input
                    type="time" disabled={cfg.closed || disabled}
                    value={cfg.open}
                    onChange={(e) => setDay(d.k, { open: e.target.value })}
                    className="h-9 w-full"
                    data-testid={`schedule-${d.k}-open`}
                  />
                  <span className="text-stone-500 text-xs">→</span>
                  <Input
                    type="time" disabled={cfg.closed || disabled}
                    value={cfg.close}
                    onChange={(e) => setDay(d.k, { close: e.target.value })}
                    className="h-9 w-full"
                    data-testid={`schedule-${d.k}-close`}
                  />
                </div>
                <label className="text-xs text-stone-400 inline-flex items-center gap-1.5 col-span-2 sm:col-span-1 justify-self-end">
                  <input type="checkbox" checked={cfg.closed} disabled={disabled}
                    onChange={(e) => setDay(d.k, { closed: e.target.checked })}
                    className="accent-amber-500" data-testid={`schedule-${d.k}-closed`} />
                  Closed
                </label>
              </div>
            );
          })}
        </div>
        {disabled && (
          <p className="mt-2 text-[11px] text-amber-300/80">
            {form.is_24_7 ? "24/7 mode — weekly schedule is ignored." : "Vacation mode — profile shown as unavailable."}
          </p>
        )}
      </Field>
    </div>
  );
}
